import React from 'react'

const SolutionsVideo = () => {
  return (
    <>
       <div className='video-container'>
          <video loop autoPlay >
             <source src="https://easycampus-dev-images.s3.ap-south-1.amazonaws.com/solutionsvideo.mp4"/>
          </video>
       </div>
    </>
  )
}

export default SolutionsVideo